export default "__VITE_ASSET__36237f3a__"